import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
//import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";

import { globalReducer, initialState as globalInitialState } from "./GlobalReducer.js";
import { adminRootReducer, initialState as adminRootInitialState } from "../Admin/Redux/AdminSlice.js";
import {
    bookingsModuleSliceReducer,
    initialState as bookingsInitialState
} from "../Modules/Bookings/Redux/BookingsModuleSliceReducer.js";
import {
    initialState as visitorsInitialState,
    visitorsModuleSliceReducer
} from "../Modules/Visitors/Redux/VisitorsModuleSliceReducer.js";
import {
    initialState as pollsInitialState,
    pollsModuleSliceReducer
} from "../Modules/Polls/Redux/PollsModuleSliceReducer.js";
import {
    keyManagementModuleSliceReducer
} from "../Modules/KeyManagement/Redux/KeyManagementModuleSliceReducer";

import { merge, throttle } from "lodash";
import { loadPersistedState, persistState } from "./Persistence";

// Example setting up store with reduxtoolkit
//export const globalRootStore = configureStore({
//    reducer: {
//        global: globalReducer,
//        module: combineReducers({
//            //['VISITORS']: visitorsRootReducer,
//            //['POLLS']: pollsRootReducer,
//            ['BOOKINGS']: bookingsModuleSliceReducer
//        })
//    }
//});

const globalRootReducer = combineReducers({
    global: globalReducer,
    module: combineReducers({
        ['BOOKINGS']: bookingsModuleSliceReducer,
        ['VISITORS']: visitorsModuleSliceReducer,
        ['POLLS']: pollsModuleSliceReducer,
        ['KEYMANAGEMENT']: keyManagementModuleSliceReducer,
    }),
    admin: adminRootReducer,
});

const initialState = {
    global: globalInitialState,
    module: {
        ['BOOKINGS']: bookingsInitialState,
        ['VISITORS']: visitorsInitialState,
        ['POLLS']: pollsInitialState,
        ['KEYMANAGEMENT']: {},
    },
    admin: adminRootInitialState,
}

const persistedState = loadPersistedState();
const preloadedState = {...window.serverVars?.preloadedReduxState ?? {}};

// TODO: Disable devtools on production. How?
const composeEnhancers = composeWithDevTools({
    trace: true,
    //traceLimit: 25
});

const globalRootStore = createStore(
    globalRootReducer,
    merge(initialState, preloadedState, persistedState),
    composeEnhancers(applyMiddleware(thunk))
);

globalRootStore.subscribe(
    throttle( () => {
        persistState(globalRootStore.getState());
    }, 2500)
);

export { globalRootStore };
